// extracted by mini-css-extract-plugin
export default {"lessonStatusContainer":"LessonStatus_lessonStatusContainer__GqksR","imgContainer":"LessonStatus_imgContainer__fAeBp","bottom":"LessonStatus_bottom__5cfQb"};